import React from 'react';

import PropTypes from 'prop-types';

import TabContext from '../TabContext';

function TabContainer(props) {
    const {
        activeId,
        children,
        className = '',
        onChange = () => undefined,
        style,
    } = props;

    return (
        <TabContext.Provider value={{
            activeId: activeId,
            onChange: onChange,
        }}>
            <div className={className} style={style}>
                {children}
            </div>
        </TabContext.Provider>
    );
}

TabContainer.propTypes = {
    activeId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    onChange: PropTypes.func,
    style: PropTypes.object,
};

export default TabContainer;
